/* GENERATED from design-system/assets/icons/checkmark.svg — do not edit.
 * Regenerate: node design-system/scripts/build-assets.mjs */
import * as React from "react";
import type { IconProps } from "./props";
const Checkmark = ({ size, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? "1em"}
    height={size ?? "1em"}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6705 6.32952C21.1098 6.76887 21.1098 7.48118 20.6705 7.92051L10.1705 18.42C9.73115 18.8594 9.01888 18.8594 8.57954 18.4201L3.32954 13.1705C2.89018 12.7312 2.89015 12.0189 3.32947 11.5795C3.76879 11.1402 4.4811 11.1402 4.92046 11.5795L9.37498 16.0336L19.0795 6.32949C19.5189 5.89016 20.2312 5.89017 20.6705 6.32952Z"
      fill="currentColor"
    />
  </svg>
);
export default Checkmark;
